import { render, staticRenderFns } from "./SProgress.vue?vue&type=template&id=455c1371&scoped=true&"
import script from "./SProgress.vue?vue&type=script&lang=ts&"
export * from "./SProgress.vue?vue&type=script&lang=ts&"
import style0 from "./SProgress.vue?vue&type=style&index=0&id=455c1371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c1371",
  null
  
)

export default component.exports